<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="ebook-toc-1" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Disclaimer</p>
<p class="Intro-text-first-paragraph ParaOverride-1"><span class="CharOverride-1">The recipes and in</span><span class="no-break CharOverride-1">formation </span><span class="CharOverride-1"> in this book are meant to</span><span class="no-break CharOverride-1"> inspire. </span><span class="CharOverride-1"> This content is not</span><span class="no-break CharOverride-1"> meant to </span><span class="CharOverride-1"> diagnose or treat any</span><span class="no-break CharOverride-1"> ailment. </span><span class="CharOverride-1"> Please consult a physician or clinical herbalist before begi</span><span class="no-break CharOverride-1">nning any </span><span class="CharOverride-1"> new herbal</span><span class="no-break CharOverride-1"> routine. </span></p>
<p class="Intro-text top1 ParaOverride-2"><span class="CharOverride-1">When foraging for herb</span><span class="no-break CharOverride-1">s, please </span><span class="CharOverride-1"> consult a professional before consumption. This</span><span class="no-break CharOverride-1"> cookbook </span><span class="CharOverride-1"> is not a foraging </span><span class="no-break CharOverride-1">guidebook </span><span class="CharOverride-1"> and canno</span><span class="no-break CharOverride-1">t be held </span><span class="CharOverride-1"> responsibl</span><span class="no-break CharOverride-1">e for any </span><span class="CharOverride-1"> mistake</span><span class="no-break CharOverride-1">s made in </span><span class="CharOverride-1"> </span><span class="no-break CharOverride-1">the wild. </span></p>
</div>
<div class="_idGenObjectLayout-1pagebreak">
<div id="_idContainer004">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ForestHome_ebook1.vue?ff768cfc